"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfirmDialog = exports.ConfirmDialogOptions = void 0;
var IctCoreJsApp_1 = require("./../Core/IctCoreJsApp");
var Logger_1 = require("./../Core/Logger");
var ConfirmDialogOptions = (function () {
    function ConfirmDialogOptions(message, postAction, confirmButtonText, cancelButtonText, redirectUrl, confirmationCallback) {
        this.message = message;
        this.postAction = postAction;
        this.confirmButtonText = confirmButtonText;
        this.cancelButtonText = cancelButtonText;
        this.redirectUrl = redirectUrl;
        this.confirmationCallback = confirmationCallback;
    }
    return ConfirmDialogOptions;
}());
exports.ConfirmDialogOptions = ConfirmDialogOptions;
var ConfirmDialog = (function () {
    function ConfirmDialog(element, options) {
        var _a, _b, _c, _d, _e;
        this.element = element;
        this.options = options;
        var message = (_a = options === null || options === void 0 ? void 0 : options.message) !== null && _a !== void 0 ? _a : element.data('confirm-message');
        var postAction = (_b = options === null || options === void 0 ? void 0 : options.postAction) !== null && _b !== void 0 ? _b : element.attr('href');
        var confirmButtonText = (_c = options === null || options === void 0 ? void 0 : options.confirmButtonText) !== null && _c !== void 0 ? _c : element.data('confirm-text');
        var cancelButtonText = (_d = options === null || options === void 0 ? void 0 : options.cancelButtonText) !== null && _d !== void 0 ? _d : element.data('cancel-text');
        var redirectUrl = (_e = options === null || options === void 0 ? void 0 : options.redirectUrl) !== null && _e !== void 0 ? _e : element.data('redirect-url');
        if (redirectUrl != null && (options === null || options === void 0 ? void 0 : options.confirmationCallback) != null) {
            Logger_1.Logger.warn('RedirectUrl will be ignored! Both the redirectUrl and the confirmationCallback are defined.');
        }
        if (postAction != null) {
            this.options = new ConfirmDialogOptions(message, postAction, confirmButtonText, cancelButtonText, redirectUrl, options === null || options === void 0 ? void 0 : options.confirmationCallback);
        }
        else {
            Logger_1.Logger.warn('The href attribute is not assigned to the element that is initialized as ConfirmDialog!');
        }
        this.OnCreate();
    }
    ConfirmDialog.prototype.OnCreate = function () {
        var _this_1 = this;
        var _this = this;
        if (_this.options != null) {
            var originalOptions_1 = _this.options;
            var options_1 = new Object();
            this.element.on('click', function (event) {
                var _a;
                event.preventDefault();
                var resetPagingOnConfirmation = true;
                if (_this_1.element && _this_1.element[0] && _this_1.element[0].attributes && _this_1.element[0].attributes['post-and-refresh-table']) {
                    resetPagingOnConfirmation = false;
                }
                options_1.message = (_a = originalOptions_1.message) !== null && _a !== void 0 ? _a : '';
                options_1.callback = function (doPost) {
                    var _a, _b;
                    if (doPost) {
                        var data;
                        var defaultDoneCallback = function () {
                            if (originalOptions_1.redirectUrl !== null && originalOptions_1.redirectUrl !== undefined) {
                                window.location.href = originalOptions_1.redirectUrl;
                            }
                            else {
                                window.location.reload();
                            }
                        };
                        if (((_a = _this.options) === null || _a === void 0 ? void 0 : _a.confirmationCallback) != null) {
                            defaultDoneCallback = _this.options.confirmationCallback;
                        }
                        IctCoreJsApp_1.$app.post((_b = originalOptions_1.postAction) !== null && _b !== void 0 ? _b : '', data, defaultDoneCallback, undefined, undefined, resetPagingOnConfirmation);
                    }
                };
                if (originalOptions_1.confirmButtonText) {
                    if (options_1.buttons === undefined) {
                        options_1.buttons = new Object();
                    }
                    options_1.buttons.confirm = {
                        label: originalOptions_1.confirmButtonText,
                        className: 'btn btn-primary'
                    };
                }
                if (originalOptions_1.cancelButtonText) {
                    if (options_1.buttons === undefined) {
                        options_1.buttons = new Object();
                    }
                    options_1.buttons.cancel = {
                        label: originalOptions_1.cancelButtonText,
                        className: 'btn btn-secondary'
                    };
                }
                IctCoreJsApp_1.$app.mdbootbox.confirm(options_1);
            });
        }
    };
    return ConfirmDialog;
}());
exports.ConfirmDialog = ConfirmDialog;
